import { WhatsappLogo, Phone } from "@phosphor-icons/react";

export default function FloatingCTAs() {
  return (
    <>
      <a
        href="https://wa.me/33546887088"
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-float"
        aria-label="WhatsApp"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] hover:bg-[#1ebd5a] text-white flex items-center justify-center shadow-lg rounded-full transition-transform hover:scale-110"
      >
        <WhatsappLogo size={28} weight="fill" />
      </a>

      <a
        href="tel:+33546887088"
        data-testid="mobile-call-cta"
        className="md:hidden fixed bottom-6 left-6 z-50 w-14 h-14 bg-[#E63946] hover:bg-[#D62839] text-white flex items-center justify-center shadow-lg rounded-full transition-transform hover:scale-110"
        aria-label="Appeler"
      >
        <Phone size={26} weight="bold" />
      </a>
    </>
  );
}
